import React from "react";
import { Dialog, DialogType, DialogFooter } from "@fluentui/react";
import { SignOutButton } from "./SignOutButton";



export const ExpiredTokenPopup = (props) => {
    const {setTokenExpired} = props;
    const dialogStyles = { main: { maxWidth: 450 } };
    const dialogContentProps = {
        type: DialogType.normal,
        title: 'Token expired',
        closeButtonAriaLabel: 'Close',
        subText: 'Your token has expired. Please log out and in again to refresh your token.',
      };
      const modalProps = {
          isBlocking: false,
          styles: dialogStyles,
          dragOptions: false,
        };

    return (
        <Dialog
        hidden={false}
        dialogContentProps={dialogContentProps}
        modalProps={modalProps}
      >
        <DialogFooter>
          <SignOutButton setTokenExpired={setTokenExpired}/>
        </DialogFooter>
      </Dialog>
    );
}